type Props = {
  label: string;
  value: string;
};

export default function Stat({ label, value }: Props) {
  return (
    <div className="flex items-baseline gap-2.5">
      <span className="font-display text-[22px] font-semibold tracking-display text-ink">{value}</span>
      <span className="text-muted">{label}</span>
    </div>
  );
}
